import $ from "jquery";
import ko from "knockout";
import "bootstrap/fontawesome-iconpicker";

function full_icon_class(icon) {
    icon = ko.unwrap(icon);
    if (!icon) 
        return "iconblock uly-icon";
    var is_ui = icon.indexOf("ui-icon-") >= 0;
    var is_fa = icon.indexOf("fa-") >= 0;
    var is_coquette = icon.indexOf("coquette") >= 0;
    var is_ion = icon.indexOf("ion-") == 0;
    if (is_coquette) {
        return "iconblock uly-icon " + icon;
    }
    else if (is_fa) {
        return "fa " + icon;
    }
    else if (is_ion) {
        return "iconblock uly-icon ui-icon ion " + icon;
    }
    else if (is_ui) {
        return "iconblock uly-icon ui-icon " + icon;
    }
    else return "iconblock uly-icon";
}

function reduced_icon_class(icon) {
    icon = ko.unwrap(icon);
    if (!icon) 
        return "";
    var is_ui = icon.indexOf("ui-icon-") >= 0;
    var is_fa = icon.indexOf("fa-") >= 0;
    var is_coquette = icon.indexOf("coquette") >= 0;
    var is_ion = icon.indexOf("ion-") === 0;
    if (is_coquette) {
        return  icon;
    }
    else if (is_fa) {
        return "fa " + icon;
    }
    else if (is_ion) {
        return "ion " + icon;
    }
    else if (is_ui) {
        return "ui-icon " + icon;
    }
    else return "fa " + icon;
}


ko.bindingHandlers.iconpicker = {
    init: function(elt, va, allbindings, viewModel, bindingContext) {
        $(elt).iconpicker({
            hideOnSelect:true,
            placement: "auto"
        }).on("iconpickerSelected", function(ev) {
            var value= ev.iconpickerValue;
            var obs = va();
            if (ko.isObservable(obs))
                obs(value);
        });
    },
    update: function(elt, va, allBindingsAccessor, viewModel, bindingContext) {
        $(elt).iconpicker("setValue", ko.unwrap(va()));
    }
};

ko.bindingHandlers.icondisplay = {
    update: function(element, va, bindings, model, context) {
        var icon = ko.utils.unwrapObservable(va());
        //is icon an fa- icon?
        //remove all classes that start with ui-icon, fa-, ion-
        var classes = $.map(($(element).attr("class")||"").split(" "), function(val,idx) {
            if (val.indexOf("fa-") == 0 || val.indexOf("ui-icon-") == 0 || val.indexOf("ion-") == 0 || val.indexOf("coquette") == 0 || val == "fa" || val == "ion" || val=="ui-icon")
                return null;
            return val;
        }).join(" ");
        
        $(element).removeClass();
        $(element).addClass(classes).addClass(full_icon_class(icon || ""));
    }
};

ko.bindingHandlers.icon = {
    update: function(element, va, bindings, model, context) {
        var iconsize = ko.unwrap(bindings().iconsize);
        var icon = ko.unwrap(va());
        var extra_classes = "fa-fw"
        if (typeof bindings().extra_classes != "undefined") {
            extra_classes = ko.unwrap(bindings().extra_classes) || "";
        }
        
        //is icon an fa- icon?
        $(element).removeClass();
        $(element).addClass(extra_classes);
        $(element).addClass(reduced_icon_class(icon || ""));
        if (iconsize) $(element).addClass("fa-" + iconsize + "x");
    }
};
